import React from 'react';
import { useTranslation, Trans } from 'next-i18next';
import Link from './components/Link/index.js';

const Item = ({ pathName, tabName, title, url, iconClassName, target }) => {
    const { t } = useTranslation('');
    return (React.createElement(Link, { href: url, className: `${iconClassName} ${pathName === tabName ? 'active' : ''}`, black: true, noUnderline: true, target: target || null },
        React.createElement(Trans, { i18nKey: title, t: t, components: { span: React.createElement("span", null) } })));
};

export { Item as I };
//# sourceMappingURL=Item-Z13RNFMm.js.map
